import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { CssBaseline } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';

import InactivityHandler from './components/InactivityHandler';
import { AuthorizationProvider } from './context/AuthorizationProvider';
import { ThemeProvider } from './context/ThemeProvider';
import Router from './pages/router';
import Unauthorized from './pages/unauthorized';

export default function App() {
  const defaultTimeout = 300000; // 5 minutos

  return (
    <ThemeProvider>
      <CssBaseline />
      {/* Enable routing if user is authenticated */}
      <AuthenticatedTemplate>
        <AuthorizationProvider>
          <InactivityHandler defaultTimeout={defaultTimeout}>
            <BrowserRouter>
              <Router />
            </BrowserRouter>
          </InactivityHandler>
        </AuthorizationProvider>
      </AuthenticatedTemplate>
      {/* Block all interaction and redirect to login */}
      <UnauthenticatedTemplate>
        <Unauthorized />
      </UnauthenticatedTemplate>
    </ThemeProvider>
  );
}
